import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';

import {CART_BUTTON} from 'constants/analytics/events/cart';
import {logWithSentry} from 'libs/sentry/sentry';

/**
 * logs error to Sentry and datalayer
 */
export const logApplePayError = (error: Error, errorText: string) => {
    logWithSentry(error, errorText);
    sendDesktopAnalyticsEvent(CART_BUTTON, {
        action: 'Apple Pay Express',
        label: `Error - ${errorText}`,
    });
};
